export const DEFAULT_SEARCH_BUTTON_LABEL = 'Find My Tires'
